import ErrorFallback from 'Components/ErrorFallback'
import AuthoritySelectionRequired from 'Services/common/Features/Authority/Components/AuthoritySelectionRequired'
import {
  DeviceCreatePage,
  DeviceEditPage,
  DeviceListPage
} from 'Services/ServiceProviderManagement/Features/Device/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function DeviceRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<DeviceListPage />} />
        <Route element={<AuthoritySelectionRequired backButtonFallbackPath="./" />}>
          <Route path="create" element={<DeviceCreatePage />} />
          <Route path=":id/edit" element={<DeviceEditPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}

export default DeviceRoot
